import { jsx as t, jsxs as n } from "react/jsx-runtime";
import N from "classnames";
import { useMemo as _ } from "react";
import { getTextColorByBarColor as C } from "./index.es2430.js";
import i from "./index.es2431.js";
import { useTheme as I } from "./index.es190.js";
import { Divider as B } from "./index.es24.js";
import { SimpleTooltip as D } from "./index.es127.js";
import { BodyText as s } from "./index.es505.js";
import { FlexContainer as d } from "./index.es584.js";
const V = "index-bar", m = "25px", b = 10, F = ({
  barValue: v,
  maxValue: x,
  entityColor: T = 1,
  showLegend: h = !0,
  testId: e = V,
  valueLabelPosition: g = "inner",
  ariaLabel: $,
  showTooltip: y
}) => {
  const l = I().activeTheme.theme.POI[T || 1].default, a = Math.max(0, v), r = Math.max(1, x), c = Math.min(100, a / r * 100), f = Math.round(r / 2), o = a >= f, p = a > r ? "inner" : g, E = N(i.bar, {
    [i.barOuterBeforeHalf]: !o,
    [i.barOuterAfterHalf]: o
  }), u = $ || `Index bar with value ${a} out of ${r}`, M = _(
    () => ({
      "--filled-portion": `${c <= b ? b : c}%`,
      "--filled-portion-color": l,
      "--filled-portion-position": o ? "unset" : "calc(100% - var(--filled-portion))"
    }),
    [l, o, c]
  );
  return /* @__PURE__ */ t(D, { title: u, isActive: y, children: /* @__PURE__ */ n(
    "div",
    {
      className: i.root,
      "data-testid": e,
      style: M,
      "data-has-legend": h,
      "data-bar-color": l,
      children: [
        /* @__PURE__ */ n(
          "div",
          {
            className: i.track,
            "data-testid": `${e}-track`,
            role: "progressbar",
            "aria-valuenow": a,
            "aria-valuemin": 0,
            "aria-valuemax": r,
            "aria-label": u,
            children: [
              /* @__PURE__ */ t(
                B,
                {
                  testId: `${e}-mid-point`,
                  "aria-hidden": "true",
                  isVertical: !0,
                  dividerLength: "26px"
                }
              ),
              /* @__PURE__ */ t(
                "div",
                {
                  className: E,
                  style: { left: o ? "50%" : "unset" },
                  "data-testid": `${e}-bar`,
                  "data-value-label-position": p,
                  children: /* @__PURE__ */ t(
                    s,
                    {
                      color: C(l, p),
                      testId: `${e}-value`,
                      element: "p",
                      variant: "bold",
                      children: a
                    }
                  )
                }
              )
            ]
          }
        ),
        h && /* @__PURE__ */ n(
          d,
          {
            justifyContent: "space-between",
            testId: `${e}-legend`,
            height: 16,
            aria: {
              "aria-hidden": "true"
            },
            children: [
              /* @__PURE__ */ t(d, { width: m, children: /* @__PURE__ */ t(s, { color: "gray", testId: `${e}-0`, children: "0" }) }),
              /* @__PURE__ */ t(d, { width: m, children: /* @__PURE__ */ t(s, { color: "gray", testId: `${e}-legend-half`, children: f }) }),
              /* @__PURE__ */ t(d, { width: m, children: /* @__PURE__ */ n(s, { color: "gray", testId: `${e}-legend-max`, children: [
                r,
                "+"
              ] }) })
            ]
          }
        )
      ]
    }
  ) });
};
export {
  V as INDEX_BAR_TEST_ID,
  F as IndexBar
};
//# sourceMappingURL=index.es151.js.map
